<template>
  <div class="avatar-chat-sfu-portal">
    <SfuWindowedCall :conversation-id="conversationId" :peer-id="peerId" />
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import SfuWindowedCall from './sfu/components/SfuWindowedCall.vue'

  const props = defineProps({
    // mode determines conversation key calculation
    mode: { type: String, default: 'campaign' }, // 'campaign' | 'direct'
    campaignId: { type: String, default: '' },
    selfUid: { type: String, default: '' },
    targetUid: { type: String, default: '' }
  })

  const peerId = computed(() => String(props.selfUid || ''))
  const conversationId = computed(() => {
    if (String(props.mode || 'campaign') === 'direct') {
      const a = String(props.selfUid || '')
      const b = String(props.targetUid || '')
      const [x, y] = [a, b].sort()
      return x && y ? `direct:${x}:${y}` : ''
    }
    const cid = String(props.campaignId || '')
    return cid ? `campaign:${cid}` : ''
  })
</script>

<style scoped>
  .avatar-chat-sfu-portal {
    width: 100%;
    height: 100%;
  }
</style>
